import { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  es: {
    // Navbar
    "nav.ruta": "Ruta",
    "nav.horario": "Horario",
    "nav.pagos": "Pagos",
    "nav.cancelacion": "Cancelación",
    "nav.nosotros": "Nosotros",
    "nav.miReserva": "Mi reserva",
    "nav.miCuenta": "Mi cuenta",
    "nav.reservarColectivo": "Reservar colectivo",
    "nav.reservarPrivada": "Reservar otras rutas privadas",
    "nav.masEquipaje": "Viajar con + equipaje",
    "nav.masEquipajeMobile": "Viaje privado o más equipaje · WhatsApp",
    "nav.wa.msg": "Hola, quiero información para un viaje privado o llevar más equipaje. Ruta Sancti Spíritus ↔ La Habana.",
    // Hero
    "hero.kicker": "Microbús 10 plazas · RutaEspirituana · Sancti Spíritus ↔ La Habana",
    "hero.title": "Un viaje directo, cómodo y seguro entre Sancti Spíritus y La Habana.",
    "hero.subtitle": "Con nuestros choferes de experiencia. Salidas lunes, miércoles y viernes. Reserva tu asiento en segundos y paga online con tarjeta, Bizum o transferencia.",
    "hero.ctaColectivo": "Reservar colectivo",
    "hero.ctaPrivada": "Otras rutas privadas",
    "hero.verRuta": "Ver ruta →",
    "hero.tarifas": "Tarifas por asiento",
    "hero.soloIda": "Solo ida",
    "hero.idaVuelta": "Ida y vuelta",
    "hero.orPrefix": "o",
    "hero.oUsd40": "o 40 USD",
    "hero.oUsd75": "o 75 USD",
    "hero.cancelFree": "Cancelación gratuita 72 horas antes",
    "hero.methods": "Tarjeta · Bizum · Transferencia · Efectivo",
    // Ruta
    "ruta.kicker": "Nuestra ruta",
    "ruta.title": "De Sancti Spíritus hasta el corazón de La Habana.",
    "ruta.desc": "Salimos temprano para llegar a tiempo. Paradas fijas en Cabaiguán y llegada a la Embajada, el Consulado, la Lonja y el Aeropuerto Internacional José Martí. Regreso el mismo día a las 4:00 PM.",
    "ruta.salida": "Salida · 3:00 AM",
    "ruta.salidaSub": "Parque Serafín Sánchez, Sancti Spíritus",
    "ruta.recogida": "Recogida · Cabaiguán",
    "ruta.recogidaSub": "Frente a la terminal municipal de ómnibus",
    "ruta.llegada": "Llegada · La Habana",
    "ruta.llegadaSub": "Embajada (Consulado) · Lonja · Aeropuerto",
    "ruta.regreso": "Regreso · 4:00 PM",
    "ruta.regresoSub": "Desde La Habana hacia Sancti Spíritus",
    "ruta.asientos": "10 asientos",
    "ruta.filas": "3 filas + copiloto",
    // Destinos
    "dest.kicker": "Nuestros destinos",
    "dest.title": "Te dejamos justo donde necesitas.",
    "dest.parque": "Sancti Spíritus · Salida 3AM",
    "dest.cabaiguan": "Recogida · Terminal ómnibus",
    "dest.embajada": "La Habana",
    "dest.lonja": "La Habana Vieja",
    "dest.aeropuerto": "Terminal 3 · La Habana",
    // Confort
    "confort.kicker": "Confort a bordo",
    "confort.title": "Nuestro microbús pensado para ti.",
    "confort.ac": "Aire acondicionado",
    "confort.acSub": "Viaja fresco todo el trayecto.",
    "confort.carga": "Puntos de carga para celular",
    "confort.cargaSub": "Llega con la batería a tope.",
    "confort.choferes": "Choferes con experiencia",
    "confort.choferesSub": "Ruta directa, sin escalas innecesarias.",
    "equipaje.kicker": "Equipaje",
    "equipaje.title": "Una mochila o bolso por pasajero.",
    "equipaje.desc": "Cada plaza incluye una mochila o bolso de mano. Si necesitas llevar más equipaje o prefieres un viaje privado, escríbenos.",
    "equipaje.boxTitle": "¿Más equipaje o viaje privado?",
    "equipaje.boxDesc": "Escríbenos por WhatsApp al",
    // Privadas
    "priv.kicker": "Rutas privadas",
    "priv.title": "Otros destinos disponibles para viajes privados.",
    "priv.desc": "Descubre Cuba con nuestros vehículos privados de 4 y 10 plazas. Choferes con experiencia y trato personalizado.",
    "priv.cta": "Reservar ruta privada",
    // Horario
    "horario.kicker": "Horario",
    "horario.title": "3 viajes colectivos por semana en el microbús.",
    "horario.mon": "Lunes",
    "horario.wed": "Miércoles",
    "horario.fri": "Viernes",
    "horario.times": "Salida 3:00 AM · Regreso 4:00 PM",
    "horario.reserva": "Reserva anticipada recomendada",
    "horario.flexible": "Somos flexibles con los horarios",
    // Pagos
    "pagos.kicker": "Métodos de pago",
    "pagos.title": "Paga como te resulte más cómodo.",
    "pagos.card": "Tarjeta bancaria (Stripe) — confirmación inmediata",
    "pagos.bizum": "Bizum al 611 841 896 (titular JAMG)",
    "pagos.transfer": "Transferencia bancaria (IBAN al finalizar la reserva)",
    "pagos.cash": "Efectivo · 24 horas para efectuar el pago",
    "pagos.cashTitle": "Pago en efectivo · 24 horas",
    "pagos.cashDesc": "Para los pagos en efectivo dispones de 24 horas para efectuarlo en cualquiera de nuestros puntos:",
    "pagos.waHint": "Por WhatsApp te indicaremos exactamente a dónde acudir.",
    "pagos.monedas": "Monedas aceptadas",
    "pagos.liberada": "Si no pagas en 24 h, la reserva se libera automáticamente.",
    // Políticas
    "pol.kicker": "Política de cancelación",
    "pol.title": "Flexibilidad clara y justa.",
    "pol.p1t": "72 horas antes",
    "pol.p1d": "Cancelación gratuita. Reembolso del 100%.",
    "pol.p2t": "Entre 72h y 48h",
    "pol.p2d": "Reembolso del 50% del total pagado.",
    "pol.p3t": "Menos de 48h",
    "pol.p3d": "No reembolsable.",
    // Quiénes somos
    "about.kicker": "Quiénes somos",
    "about.title": "Una agencia de viajes particular, hecha para facilitarte el camino.",
    "about.desc": "Somos una agencia de viajes particular dentro de Cuba, con choferes experimentados. Nuestro objetivo es hacerte la vida más fácil: que puedas, desde cualquier parte del mundo, reservar los traslados dentro de Cuba para ti, tu familia o tus amigos de una manera justa, transparente y sin contratiempos. Ofrecemos viajes colectivos y privados.",
    "about.sedesTitle": "Nuestras sedes",
    "about.sedes": "Cabaiguán · Sancti Spíritus · La Habana · Tenerife · Gran Canaria",
    "about.destinosTitle": "Destinos que cubrimos",
    "about.destinos": "La Habana (Consulado, Lonja del Comercio, aeropuertos), Viñales, Varadero, Matanzas, Santa Clara, Cienfuegos, Cayo Coco, Cayo Guillermo, Ciego de Ávila, Camagüey y más.",
    "about.b1": "Choferes con experiencia",
    "about.b2": "Precios justos y transparentes",
    "about.b3": "Reserva desde cualquier parte del mundo",
    // Choferes / trabaja con nosotros
    "driver.kicker": "Trabaja con nosotros",
    "driver.title": "¿Tienes carro? ¿Quieres trabajar con nosotros?",
    "driver.desc": "Únete a nuestra red de choferes. Envíanos tus datos y una foto de tu vehículo; te contactaremos para valorar las rutas.",
    "driver.name": "Nombre completo",
    "driver.phone": "Teléfono",
    "driver.location": "¿Dónde radicas?",
    "driver.carType": "Tipo de coche",
    "driver.routes": "Rutas y tarifas aproximadas",
    "driver.photo": "Foto del vehículo",
    "driver.photoHint": "JPG o PNG · máx. 6 MB",
    "driver.submit": "Enviar solicitud",
    "driver.sending": "Enviando…",
    "driver.success": "¡Solicitud enviada! Te contactaremos pronto.",
    "driver.error": "No se pudo enviar. Inténtalo de nuevo.",
    "driver.required": "Completa nombre, teléfono, dónde radicas y tipo de coche.",
    "footer.admin": "Acceso administrador",
  },
  en: {
    // Navbar
    "nav.ruta": "Route",
    "nav.horario": "Schedule",
    "nav.pagos": "Payments",
    "nav.cancelacion": "Cancellation",
    "nav.nosotros": "About",
    "nav.miReserva": "My booking",
    "nav.miCuenta": "My account",
    "nav.reservarColectivo": "Book shared trip",
    "nav.reservarPrivada": "Book private routes",
    "nav.masEquipaje": "Travel with + luggage",
    "nav.masEquipajeMobile": "Private trip or extra luggage · WhatsApp",
    "nav.wa.msg": "Hi, I'd like information about a private trip or carrying extra luggage. Route Sancti Spíritus ↔ Havana.",
    // Hero
    "hero.kicker": "10-seat minibus · RutaEspirituana · Sancti Spíritus ↔ Havana",
    "hero.title": "A direct, comfortable and safe trip between Sancti Spíritus and Havana.",
    "hero.subtitle": "With our experienced drivers. Departures Monday, Wednesday and Friday. Book your seat in seconds and pay online by card, Bizum or bank transfer.",
    "hero.ctaColectivo": "Book shared trip",
    "hero.ctaPrivada": "Other private routes",
    "hero.verRuta": "See route →",
    "hero.tarifas": "Fares per seat",
    "hero.soloIda": "One way",
    "hero.idaVuelta": "Round trip",
    "hero.orPrefix": "or",
    "hero.oUsd40": "or 40 USD",
    "hero.oUsd75": "or 75 USD",
    "hero.cancelFree": "Free cancellation up to 72 hours before",
    "hero.methods": "Card · Bizum · Transfer · Cash",
    // Ruta
    "ruta.kicker": "Our route",
    "ruta.title": "From Sancti Spíritus to the heart of Havana.",
    "ruta.desc": "We leave early to arrive on time. Fixed stops in Cabaiguán and arrival at the Embassy, the Consulate, La Lonja and José Martí International Airport. Same-day return at 4:00 PM.",
    "ruta.salida": "Departure · 3:00 AM",
    "ruta.salidaSub": "Serafín Sánchez Park, Sancti Spíritus",
    "ruta.recogida": "Pick-up · Cabaiguán",
    "ruta.recogidaSub": "Opposite the municipal bus terminal",
    "ruta.llegada": "Arrival · Havana",
    "ruta.llegadaSub": "Embassy (Consulate) · La Lonja · Airport",
    "ruta.regreso": "Return · 4:00 PM",
    "ruta.regresoSub": "From Havana to Sancti Spíritus",
    "ruta.asientos": "10 seats",
    "ruta.filas": "3 rows + front seat",
    // Destinos
    "dest.kicker": "Our destinations",
    "dest.title": "We drop you exactly where you need to be.",
    "dest.parque": "Sancti Spíritus · 3AM departure",
    "dest.cabaiguan": "Pick-up · Bus terminal",
    "dest.embajada": "Havana",
    "dest.lonja": "Old Havana",
    "dest.aeropuerto": "Terminal 3 · Havana",
    // Confort
    "confort.kicker": "Comfort on board",
    "confort.title": "Our minibus designed for you.",
    "confort.ac": "Air conditioning",
    "confort.acSub": "Travel cool the whole way.",
    "confort.carga": "Phone charging points",
    "confort.cargaSub": "Arrive with a full battery.",
    "confort.choferes": "Experienced drivers",
    "confort.choferesSub": "Direct route, no unnecessary stops.",
    "equipaje.kicker": "Luggage",
    "equipaje.title": "One backpack or bag per passenger.",
    "equipaje.desc": "Each seat includes one backpack or carry-on bag. If you need to carry more luggage or prefer a private trip, message us.",
    "equipaje.boxTitle": "More luggage or a private trip?",
    "equipaje.boxDesc": "Message us on WhatsApp at",
    // Privadas
    "priv.kicker": "Private routes",
    "priv.title": "Other destinations available for private trips.",
    "priv.desc": "Discover Cuba with our private 4- and 10-seat vehicles. Experienced drivers and personalized service.",
    "priv.cta": "Book private route",
    // Horario
    "horario.kicker": "Schedule",
    "horario.title": "3 shared minibus trips per week.",
    "horario.mon": "Monday",
    "horario.wed": "Wednesday",
    "horario.fri": "Friday",
    "horario.times": "Departure 3:00 AM · Return 4:00 PM",
    "horario.reserva": "Early booking recommended",
    "horario.flexible": "We are flexible with schedules",
    // Pagos
    "pagos.kicker": "Payment methods",
    "pagos.title": "Pay whichever way suits you best.",
    "pagos.card": "Bank card (Stripe) — instant confirmation",
    "pagos.bizum": "Bizum to 611 841 896 (holder JAMG)",
    "pagos.transfer": "Bank transfer (IBAN provided at checkout)",
    "pagos.cash": "Cash · 24 hours to make the payment",
    "pagos.cashTitle": "Cash payment · 24 hours",
    "pagos.cashDesc": "For cash payments you have 24 hours to pay at any of our points:",
    "pagos.waHint": "On WhatsApp we'll tell you exactly where to go.",
    "pagos.monedas": "Accepted currencies",
    "pagos.liberada": "If you don't pay within 24h, the booking is released automatically.",
    // Políticas
    "pol.kicker": "Cancellation policy",
    "pol.title": "Clear and fair flexibility.",
    "pol.p1t": "72 hours before",
    "pol.p1d": "Free cancellation. 100% refund.",
    "pol.p2t": "Between 72h and 48h",
    "pol.p2d": "50% refund of the total paid.",
    "pol.p3t": "Less than 48h",
    "pol.p3d": "Non-refundable.",
    // About us
    "about.kicker": "About us",
    "about.title": "A private travel agency, built to make your journey easier.",
    "about.desc": "We are a private travel agency inside Cuba, with experienced drivers. Our goal is to make your life easier: so that, from anywhere in the world, you can book transfers within Cuba for yourself, your family or your friends in a fair, transparent and hassle-free way. We offer both shared and private trips.",
    "about.sedesTitle": "Our offices",
    "about.sedes": "Cabaiguán · Sancti Spíritus · Havana · Tenerife · Gran Canaria",
    "about.destinosTitle": "Destinations we cover",
    "about.destinos": "Havana (Consulate, Lonja del Comercio, airports), Viñales, Varadero, Matanzas, Santa Clara, Cienfuegos, Cayo Coco, Cayo Guillermo, Ciego de Ávila, Camagüey and more.",
    "about.b1": "Experienced drivers",
    "about.b2": "Fair and transparent prices",
    "about.b3": "Book from anywhere in the world",
    // Drivers / work with us
    "driver.kicker": "Work with us",
    "driver.title": "Have a car? Want to work with us?",
    "driver.desc": "Join our network of drivers. Send us your details and a photo of your vehicle; we'll contact you to review the routes.",
    "driver.name": "Full name",
    "driver.phone": "Phone",
    "driver.location": "Where are you based?",
    "driver.carType": "Car type",
    "driver.routes": "Approximate routes and fares",
    "driver.photo": "Vehicle photo",
    "driver.photoHint": "JPG or PNG · max. 6 MB",
    "driver.submit": "Send application",
    "driver.sending": "Sending…",
    "driver.success": "Application sent! We'll contact you soon.",
    "driver.error": "Could not send. Please try again.",
    "driver.required": "Please fill in name, phone, location and car type.",
    "footer.admin": "Admin access",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "es");
  const setLang = useCallback((l) => {
    localStorage.setItem("lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => (DICT[lang] && DICT[lang][key]) || DICT.es[key] || key, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
